module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/one-dc2d3.png";